var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-header" },
    [
      _c("ChatCloseSettingsButton", {
        attrs: {
          contact: _vm.contact,
          autoTranslateEnabled: _vm.autoTranslateEnabled,
          "is-watching": _vm.isWatching,
        },
        on: { autoTranslateChanged: _vm.autoTranslateChanged },
      }),
      _vm._v(" "),
      _c("TranslateDetected", {
        attrs: { contact: _vm.contact },
        on: { "auto-translate": _vm.autoTranslateChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }